import { ADDITIONAL_PARTICIPANT_EVENTS } from '../../../event_bus_modules/additional_participant';
import {
  initializeForm,
  appendAndGetUniqueFormElement,
} from '../../../utils/form';
import {
  validateEmail,
  validateNotEmpty,
  validateValueNotTaken,
} from '../../../utils/validators';

$(() => {
  const auctionId = parseInt($('input#_current-auction-id').val());
  const auctionInCartId = $('input#_current-auction-in-cart-id').val();
  const primaryPurchaserEmail = $('input#_primary_purchaser_email').val();

  const initializeAdditionalParticipantComponent = (element) => {
    const $element = $(element);
    const csrfToken = $element.find('input[name="csrfmiddlewaretoken"]').val();
    const participantType = $element.attr('data-participant-type');
    const multiplePersonsAllowed =
      $element.attr('data-multiple-persons-allowed') === 'True';
    const newPersonForm = $element.find(
      '.additional-participant__add-person-form'
    );
    const addedPersonsSection = $element.find(
      '.additional-participant__added-persons'
    );
    const addingSection = $element.find(
      '.additional-participant__adding-section'
    );
    const addedPersonsRemoveButtons = addedPersonsSection.find('button');
    const linkedPersonsDropdown = $element.find(
      '.additional-participant__linked-persons-dropdown'
    );
    const linkedPersonsDropdownInput = linkedPersonsDropdown.find(
      '.select-field__input'
    );

    const hasAddedPersons = () => {
      return addedPersonsSection.children().length;
    };

    const inviteAdditionalParticipantForm = appendAndGetUniqueFormElement({
      $elementToAppend: $('#auction-registration-content'),
      $formFields: newPersonForm,
    });

    const newPersonFormInstance = initializeForm(
      inviteAdditionalParticipantForm,
      {
        formFieldsWrapper: newPersonForm,
        initialValues: {
          'first-name': '',
          'last-name': '',
          email: '',
        },
        preventDefault: true,
        validate: (values) => {
          const errors = {
            ...validateEmail(values),
            ...validateValueNotTaken(values, 'email', {
              valuesTaken: [primaryPurchaserEmail],
            }),
            ...validateNotEmpty(values, ['first-name', 'last-name']),
          };

          const hasErrors = !$.isEmptyObject(errors);
          $element.find('input[type="submit"]').attr('disabled', hasErrors);

          return errors;
        },
        onSubmit: (values) => {
          const {
            email,
            'first-name': firstName,
            'last-name': lastName,
          } = values;
          EVENT_BUS.dispatch(
            ADDITIONAL_PARTICIPANT_EVENTS.ADD_NEW_PARTICIPANT,
            {
              csrfToken,
              type: participantType,
              email,
              firstName,
              lastName,
              auctionId,
            }
          );
        },
      }
    );

    const updateAddingSectionState = () => {
      if (!multiplePersonsAllowed) {
        if (hasAddedPersons()) {
          addingSection.addClass('disabled');
          addingSection.find('input').attr('tabindex', -1);
        } else {
          addingSection.removeClass('disabled');
          addingSection.find('input').attr('tabindex', 0);
        }
      }
    };

    const onLinkedPersonSelected = (event) => {
      const { value } = event.detail;
      const id = parseInt(value);
      if (!isNaN(id)) {
        EVENT_BUS.dispatch(ADDITIONAL_PARTICIPANT_EVENTS.SELECT_PARTICIPANT, {
          type: participantType,
          id,
          auctionId,
          csrfToken,
        });
      }
      updateDropdownSelectedState();
    };

    const onRemovePersonRowClicked = (event) => {
      event.preventDefault();
      const { parentElement } = event.target;
      const id = parseInt($(parentElement).attr('data-id'));
      EVENT_BUS.dispatch(ADDITIONAL_PARTICIPANT_EVENTS.REMOVE_PARTICIPANT, {
        type: participantType,
        id,
        csrfToken,
        auctionId,
      });
    };

    const removePersonRow = (id) => {
      const rowToBeRemoved = addedPersonsSection.find(
        `.additional-participant__added-person-row[data-id="${id}"]`
      );
      rowToBeRemoved.remove();
    };

    const addNewRow = ({ id, email, firstName, lastName }) => {
      const newRow = `
            <div class="additional-participant__added-person-row" data-id="${id}">
                <div class="additional-participant__added-person-name">
                    ${firstName} ${lastName}
                    <span class="d-block d-lg-none">${email}</span>
                </div>
                <div class="d-none d-lg-block">${email}</div>
                <button class="remove-x-button"></button>
            </div>
        `;
      addedPersonsSection.append(newRow).show();

      // adds remove functionality to new row ('hydrates' newly created template)
      const newPersonRemoveButton = $element.find(
        `.additional-participant__added-person-row[data-id="${id}"] button`
      );
      newPersonRemoveButton.on('click', onRemovePersonRowClicked);
    };

    const updateDropdownOptions = (participants) => {
      // clears current options
      linkedPersonsDropdown.find('.select-field__dropdown').empty();
      // adds new options
      participants.forEach((participant) => {
        const { first_name: firstName, last_name: lastName, id } = participant;
        addDropdownOption({ firstName, lastName, id });
      });
    };

    const addDropdownOption = ({ firstName, lastName, id }) => {
      const newDropdownOption = `
            <div
              class="select-field__dropdown-item pl-2 py-1"
              data-option-value="${id}"
            >
                ${firstName} ${lastName}
            </div>
        `;
      linkedPersonsDropdown
        .find('.select-field__dropdown')
        .append(newDropdownOption);
    };

    const updateDropdownSelectedState = () => {
      linkedPersonsDropdownInput
        .val('')
        .trigger('change')
        .trigger('clearSelect', [false]);
    };

    const resetForm = () => {
      newPersonForm
        .find("input:not([name='submit'])")
        .val('')
        .trigger('change');
      newPersonFormInstance.restart();
    };

    const hideAddedPersonsSectionIfEmpty = () => {
      const addedPersonsRows = addedPersonsSection.find(
        '.additional-participant__added-person-row'
      );
      if (addedPersonsRows.length === 0) {
        addedPersonsSection.hide();
      }
    };

    const requestAvailableParticipantsLists = () => {
      EVENT_BUS.dispatch(
        ADDITIONAL_PARTICIPANT_EVENTS.GET_AVAILABLE_PARTICIPANTS_LIST,
        { csrfToken, auctionInCartId }
      );
    };

    // disables adding section on init if necessary
    updateAddingSectionState();
    hideAddedPersonsSectionIfEmpty();

    addedPersonsRemoveButtons.on('click', onRemovePersonRowClicked);

    linkedPersonsDropdownInput.on('selectChange', onLinkedPersonSelected);

    EVENT_BUS.on(
      ADDITIONAL_PARTICIPANT_EVENTS.ADDED_NEW_PARTICIPANT,
      ({ id, lastName, firstName, email, type }) => {
        if (type === participantType) {
          addNewRow({ id, lastName, firstName, email });
          updateAddingSectionState();
          requestAvailableParticipantsLists();
        }
      }
    );

    EVENT_BUS.on(
      ADDITIONAL_PARTICIPANT_EVENTS.ADDED_SELECTED_PARTICIPANT,
      ({ id, lastName, firstName, email, type }) => {
        if (type === participantType) {
          addNewRow({ id, lastName, firstName, email });
          updateAddingSectionState();
        }
      }
    );

    EVENT_BUS.on(
      ADDITIONAL_PARTICIPANT_EVENTS.REMOVED_PARTICIPANT,
      ({ id, type }) => {
        if (type === participantType) {
          removePersonRow(id);
          hideAddedPersonsSectionIfEmpty();
          updateAddingSectionState();
          requestAvailableParticipantsLists();
        }
      }
    );

    EVENT_BUS.on(
      ADDITIONAL_PARTICIPANT_EVENTS.RESET_PARTICIPANT_FORM,
      ({ type }) => {
        if (type === participantType) {
          setTimeout(resetForm);
        }
      }
    );

    EVENT_BUS.on(
      ADDITIONAL_PARTICIPANT_EVENTS.UPDATE_AVAILABLE_PARTICIPANTS_LIST,
      ({ available_additional_participants }) => {
        updateDropdownOptions(available_additional_participants);
      }
    );
  };

  const components = $('.additional-participant');
  components.each((_, componentElement) =>
    initializeAdditionalParticipantComponent(componentElement)
  );
});
